/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_This_DeviceInputs */

const en_notify_this_device = /** @type {(inputs: Notify_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this device`)
};

const de_notify_this_device = /** @type {(inputs: Notify_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Gerät`)
};

/**
* | output |
* | --- |
* | "On this device" |
*
* @param {Notify_This_DeviceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_this_device = /** @type {((inputs?: Notify_This_DeviceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_This_DeviceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_this_device(inputs)
	return en_notify_this_device(inputs)
});